import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowRightLong = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 34,
	height: 18,
	viewBox: "0 0 34 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M1 9L31.73 9",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "square",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M24.823 2L32.878 9L24.823 16",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "square",
		strokeLinejoin: "round"
	})]
});
export default SvgArrowRightLong;
